import { useMemo } from 'react';
import { Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import SimpleCard from '../../../SimpleCard';

import ScreeningPreferencesTextButton from '../../../ScreeningPreferencesTextButton';

type Props = {
  showScreeningCriteriaCTA?: boolean;
};

const EmptyInquiriesCardSimple = ({ showScreeningCriteriaCTA }: Props) => {
  const renderBodyContent = useMemo(() => {
    return showScreeningCriteriaCTA ? (
      <>
        <Spacer marginBottom="sm">
          <Text asChild textStyle="body-sm">
            <p>
              When a renter contacts you, help make a good first impression by responding within 24 hours. While you
              wait, get ready to attract the right renters for you.
            </p>
          </Text>
        </Spacer>

        <ScreeningPreferencesTextButton />
      </>
    ) : (
      `When a renter contacts you, help make a good first impression by responding within 24 hours. Replying to
      every inquiry as quickly as you can will help give renters a good impression of you and create a better
      experience for Zillow users.`
    );
  }, [showScreeningCriteriaCTA]);

  return (
    <div data-testid="EmptyInquiriesCardSimple">
      <SimpleCard bodyHeading="No inquiries yet" body={renderBodyContent} withChevron={false} />
    </div>
  );
};

export default EmptyInquiriesCardSimple;
